import moment from "moment"

function parseKpiValue(value) {
	if (value === null || value === undefined || value === "") {
		return null
	}
	const parsed = parseInt(value, 10)
	return isNaN(parsed) ? null : parsed
}

export function buildKpiHistoryChartEntries(history, maxEntries = 5) {
	return [...history]
		.sort((a, b) => (b.evaluationDate || 0) - (a.evaluationDate || 0))
		.slice(0, maxEntries)
		.map((entry) => ({
			label: entry.evaluationDate
				? moment(entry.evaluationDate).format("D MMM YYYY")
				: "—",
			delivery: parseKpiValue(entry.deliveryKpi),
			quality: parseKpiValue(entry.qualityKpi),
			support: parseKpiValue(entry.supportKpi),
		}))
}
